@if (state$ | async; as state) {
  @if (state.data?.endDate) {
    <div class="info-section ue-section">
      <div class="info-section__header">
        <div class="info-section__icon">
          <i class="fa fa-exclamation-triangle"></i>
        </div>
        <h3 class="info-section__title">{{ getTitleKey(state.data) | translate }}</h3>
      </div>
      <div class="ue-date-row">
        <span class="ue-date">{{ state.data.endDate | date:'dd/MM/yyyy' }}</span>
        <span class="popover-container">
          <svg
            class="ue-info-icon"
            role="button"
            tabindex="0"
            (click)="togglePopover($event)"
            [attr.aria-label]="getTitleKey(state.data) | translate"
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            viewBox="0 0 16 16">
            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
            <path d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0M7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0z"/>
          </svg>
          @if (isPopoverVisible) {
            <span class="popover-content">{{ getTooltipKey(state.data) | translate }}</span>
          }
        </span>
      </div>
    </div>
  }
}
